import { Skeleton } from "@repo/components/src/ui/skeleton";
import { VStack } from "@repo/components/src/ui/vstack";
import React from "react";

const LoadingState = React.memo(() => (
  <VStack space="md" className="w-full">
    <Skeleton variant="rounded" className="h-28" />
    <Skeleton variant="rounded" className="h-16" />
    <Skeleton variant="rounded" className="h-44" />
    <Skeleton variant="rounded" className="h-72" />
    <Skeleton variant="rounded" className="h-72" />
  </VStack>
));

LoadingState.displayName = "ReportLoadingState";

export default LoadingState;
